import { Button, Dropdown, Form, Input, Menu, Modal, Space, Spin, message } from 'antd';
import moment from 'moment';
import { useState } from "react";
import { connect } from 'react-redux';

import SPCService from "../../redux/services/spc";
const key = "updatable"

const AddSPC = (props) => {
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [sampleDataLabel, setSampleDataLabel] = useState('Sample Data');

    const [spc, setSPC] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [boardForm] = Form.useForm(null);
    const [boardFormData, setBoardFormData] = useState(null);

    const loadInitialValues = async () => {
        setLoading(true);
        let spcResponse = await SPCService.fetchSPC(props?.spcId);
        setSPC(spcResponse);
        let res = await SPCService.fetchBatchId(props?.spcId);
        boardForm.setFieldsValue({ "batch_id": res.batch_id });
        setLoading(false);
        if (spcResponse?.chart_type == 'P') {
            setSampleDataLabel('Total Defectives')
        }
        else if (spcResponse?.chart_type == 'NP') {
            setSampleDataLabel('Total Defectives')
        }
        else if (spcResponse?.chart_type == 'U') {
            setSampleDataLabel('Total Defects')
        }
        else if (spcResponse?.chart_type == 'C') {
            setSampleDataLabel('Total Defects')
        }

    }

    const validateAttrSampleData = (input, sample_size) => {


        //|| spc?.chart_type == 'C' || spc?.chart_type == 'U'
        // if (spc?.chart_type == 'NP' || spc?.chart_type == 'P') {
        //     if (parseInt(input) <= 0) {
        //         return { isValid: false, message: `Value must be greater than zero.` };
        //     }
        // }

        if (spc?.chart_type == 'C' || spc?.chart_type == 'U' || spc?.chart_type == 'NP' || spc?.chart_type == 'P') {
            if (parseInt(input) < 0) {
                return { isValid: false, message: `Value must be greater than or equal to zero.` };
            }
        }

        if (spc?.chart_type == 'P' || spc?.chart_type == 'U') {
            if (parseInt(sample_size) <= 0) {
                return { isValid: false, message: `Sample Size must be greater than or equal to 0.`, 'field': 'sample_size' };
            }
        }



        if (spc?.chart_type == 'NP' || spc?.chart_type == 'C') {
            sample_size = spc?.sample_size;
            if (parseInt(input) > sample_size) {
                return { isValid: false, message: `Value must be less than or equal to sample size.` };
            }
        }

        const decimalRegex = /^-?\d+(\.\d+)?$/;
        // Check if value is a valid decimal or integer
        if (!decimalRegex.test(input)) {
            return { isValid: false, message: `Invalid decimal/integer value: "${input}"` };
        }
        // Parse the value as a number
        const numericValue = parseFloat(input);
        return { isValid: true, message: "All values are valid.", "data": [numericValue] };

    }
    const validateSampleData = (input, min_value, max_value) => {
        const allowed_decimal_places = spc.allowed_decimal_places;
        const sample_in_inches = spc.sample_in_inches;
        // Split the input by commas
        const values = input.split(',');
        let data = [];

        if (spc?.sample_size != values.length) {
            return { isValid: false, message: `Data points must be equals to sample size` };
        }


        // Iterate through each value to validate
        for (let i = 0; i < values.length; i++) {
            const value = values[i].trim(); // Trim whitespace
            let numericValue = 0;

            if (sample_in_inches) {
                try {
                    numericValue = eval(value);
                }
                catch (error) {
                    return { isValid: false, message: `Invalid input value: "${value}"` };
                }
                // Parse the value as a number
                numericValue = parseFloat(numericValue);
            }
            else {
                const decimalRegex = /^-?\d+(\.\d+)?$/;
                // Check if value is a valid decimal or integer
                if (!decimalRegex.test(value)) {
                    return { isValid: false, message: `Invalid decimal/integer value: "${value}"` };
                }
                numericValue = parseFloat(value);
            }

            // ✅ Decimal places check (only if sample_in_inches = false)
            if (allowed_decimal_places === 0) {
                // must be integer
                if (numericValue.toString().includes(".")) {
                    return {
                        isValid: false,
                        message: `The value "${value}" must be an integer (no decimals allowed).`
                    };
                }
            } else {
                const parts = numericValue.toString().split(".");
                if (parts.length === 2) {
                    const decimals = parts[1].length;
                    if (decimals > allowed_decimal_places) {
                        return {
                            isValid: false,
                            message: `The value "${value}" has too many decimal places (allowed up to ${allowed_decimal_places}).`
                        };
                    }
                }
            }

            // Check if value is within the range of lcl and ucl
            if (numericValue < min_value || numericValue > max_value) {
                return { isValid: false, message: `The value "${value}" is out of acceptable range (${min_value}-${max_value}).` };
            }
            data.push(numericValue);
        }
        return { isValid: true, message: "All values are valid.", "data": data };
    }

    const handleOnOk = () => {
        setLoading(true);
        boardForm.validateFields().then((data) => {
            let validate = { isValid: false };
            if (spc?.chart_type == 'NP' || spc?.chart_type == 'C' || spc?.chart_type == 'U' || spc?.chart_type == 'P') {
                validate = validateAttrSampleData(data.sample_data, data.sample_size, boardForm)
            }
            else {
                validate = validateSampleData(data.sample_data, parseFloat(spc.min_value), parseFloat(spc.max_value))
            }
            if (validate.isValid == false) {
                if (validate?.field == 'sample_size') {
                    boardForm.setFields([
                        {
                            "name": "sample_size",
                            "errors": [validate.message]
                        }
                    ]);
                }
                else {
                    boardForm.setFields([
                        {
                            "name": "sample_data",
                            "errors": [validate.message]
                        }
                    ]);
                }

                setLoading(false);
            }
            else {
                let spcType = ''
                if (spc?.chart_type == 'X-MR')
                    spcType = "imr"
                else if (spc?.chart_type == 'X-Bar-R')
                    spcType = "xbar";
                else
                    spcType = spc?.chart_type;

                let payload = {
                    "spc_id": props?.spcId,
                    "batch_id": data.batch_id,
                    "notes": data.notes,
                    "data": spcType == 'imr' ? validate.data[0] : validate.data,
                    "timestamp": moment().format('YYYY-MM-DD HH:mm:ss')
                }
                if (spc?.chart_type == 'P' || spc?.chart_type == 'U') {
                    payload["sample_size"] = data.sample_size;
                }
                if (spc?.chart_type == 'NP' || spc?.chart_type == 'C') {
                    payload["sample_size"] = spc.sample_size;
                }

                setSubmitting(true);
                SPCService.addDataPoint(payload, spcType).then((res) => {
                    setSubmitting(false);
                    setLoading(false);
                    message.success({ content: "Data point added successfully.", key });
                    setModalVisible(false);
                    props?.onSuccess();
                }).catch((res) => {
                    if (res?.response?.data?.message != null || res?.response?.data?.message != undefined) {
                        message.error({ content: res?.response?.data?.message, key });
                    }
                    setLoading(false);
                    setSubmitting(false);
                });
            }
        }).catch((info) => {

            setLoading(false);
            console.log('Validate Failed:', info);
        });

    }
    const clearData = () => {
        setModalVisible(false);
    }


    const menu = (
        <Menu>
            <Menu.Item key="0">
                <Button type='primary' onClick={() => { props?.onDelete() }} ghost danger style={{ width: '100%' }}>Delete</Button>
            </Menu.Item>
            <Menu.Item key="1">
                <Button type='primary' onClick={() => { props?.onCalculateLimit() }} ghost style={{ width: '100%' }}>Calculate Limit</Button>
            </Menu.Item>
            <Menu.Item key="3">
                <Button type='primary' onClick={() => { props?.onRefresh() }} ghost style={{ width: '100%' }}>Reload Graph</Button>
            </Menu.Item>
            <Menu.Item key="4">
                <Button
                    type='primary'
                    onClick={() => { props?.onMachineDown(); }}
                    ghost
                    danger={!props?.isMachineDown}
                    style={{ width: '100%', borderColor: props?.isMachineDown ? '#faad14' : undefined, color: props?.isMachineDown ? '#faad14' : undefined }}
                >
                    {props?.isMachineDown ? 'Mark Machine as Up' : 'Mark Machine as Down'}
                </Button>
            </Menu.Item>
        </Menu>
    );

    return (
        <div>
            {
                props?.user?.permissions?.can_add_spc_on_web == true ? (
                    <div className="header" style={{ width: '100%', height: 45, backgroundColor: '#ccc', padding: 5, textAlign: 'right' }}>
                        <Space direction="vertical">
                            {/* <Dropdown.Button
                                type="primary"
                                onClick={() => {
                                    setModalVisible(true);
                                    loadInitialValues();
                                }}
                                menu={{
                                    items,
                                }}
                            >
                                Add New
                            </Dropdown.Button> */}

                            <Dropdown.Button type="primary" overlay={menu} onClick={() => {
                                setModalVisible(true);
                                loadInitialValues();
                            }}>
                                Add New
                            </Dropdown.Button>
                        </Space>



                        <Modal
                            // forceRender
                            closable={true}
                            // open={true}
                            visible={modalVisible}
                            title={"Add New Data"}
                            onOk={handleOnOk}
                            onCancel={clearData}
                            centered={true}
                            destroyOnClose={true}
                            footer={
                                [
                                    <Button key="back" onClick={clearData}>
                                        Cancel
                                    </Button>,
                                    <Button key="submit" type="primary" loading={submitting} onClick={handleOnOk}>
                                        Submit
                                    </Button>,
                                ]
                            }
                        >
                            <Spin tip="Loading..." spinning={loading}>
                                <div>
                                    <table className='table table-bordered'>
                                        <tbody>
                                            <tr>
                                                <td>Cell No</td>
                                                <td>{spc?.cell_number}</td>
                                                <td>Characterstic</td>
                                                <td>{spc?.characteristic}</td>
                                            </tr>
                                            {
                                                (spc?.chart_type == 'U' || spc?.chart_type == 'P' || spc?.chart_type == 'NP' || spc?.chart_type == 'C') ? null : (
                                                    <>
                                                        <tr>
                                                            <td>Min</td>
                                                            <td>{spc?.min_value}</td>
                                                            <td>Max</td>
                                                            <td>{spc?.max_value}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>LSL</td>
                                                            <td>{spc?.lsl}</td>
                                                            <td>USL</td>
                                                            <td>{spc?.usl}</td>
                                                        </tr>
                                                    </>
                                                )
                                            }


                                            <tr>
                                                {(spc?.chart_type == 'U' || spc?.chart_type == 'P') ? <>
                                                    <td></td>
                                                    <td></td>
                                                </> : (
                                                    <>
                                                        <td>Sample Size</td>
                                                        <td>{spc?.sample_size}</td>
                                                    </>
                                                )}

                                                {
                                                    (spc?.chart_type == 'U' || spc?.chart_type == 'P' || spc?.chart_type == 'NP' || spc?.chart_type == 'C') ?
                                                        <>
                                                            <td></td>
                                                            <td></td>
                                                        </> : (
                                                            <>
                                                                <td>UCL/LCL Calculated at</td>
                                                                <td>{spc?.limit_calculated_at != null ? new Date(spc?.limit_calculated_at).toLocaleString() : "-"}</td>
                                                            </>
                                                        )
                                                }

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <Form
                                    preserve={false}
                                    form={boardForm}
                                    initialValues={boardFormData}
                                    labelCol={{ span: 24 }}
                                    layout={"vertical"}
                                    wrapperCol={{ span: 24 }}
                                    autoComplete="off">

                                    <Form.Item label="Batch ID" name="batch_id" rules={[{ required: true, message: 'This field is required!' }]}>
                                        <Input autoFocus={false} />
                                    </Form.Item>
                                    <Form.Item label="Notes" name="notes">
                                        <Input autoFocus={false} />
                                    </Form.Item>
                                    {
                                        (spc?.chart_type == 'U' || spc?.chart_type == 'P') ? (
                                            <Form.Item label="Sample Size" name="sample_size" rules={[{ required: true, message: 'This field is required!' }]}>
                                                <Input autoFocus={true} />
                                            </Form.Item>
                                        ) : null
                                    }
                                    <Form.Item label={sampleDataLabel} name="sample_data" rules={[{ required: true, message: 'This field is required!' }]}>
                                        <Input autoFocus={true} />
                                    </Form.Item>
                                </Form>
                            </Spin>
                        </Modal>

                    </div>

                ) : null
            }
        </div >
    );
};

function mapStateToProps(state) {
    const { auth } = state;
    const { token, user } = auth;
    return {
        token, user
    }
}

export default connect(mapStateToProps)(AddSPC);